/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Showselectedonly3Inputs */

const en_datagrid_showselectedonly3 = /** @type {(inputs: Datagrid_Showselectedonly3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show selected only`)
};

/**
* | output |
* | --- |
* | "Show selected only" |
*
* @param {Datagrid_Showselectedonly3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_showselectedonly3 = /** @type {((inputs?: Datagrid_Showselectedonly3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Showselectedonly3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_showselectedonly3(inputs)
});
export { datagrid_showselectedonly3 as "dataGrid_showSelectedOnly" }